"use client";
import {
  Image_default
} from "./chunk-KBWHYFNM.mjs";
import {
  Button_default
} from "./chunk-WBZIOSC6.mjs";

// src/components/sections/DefaultHero/DefaultHero.tsx
import { forwardRef } from "react";
import classNames from "classnames";
import { jsx, jsxs } from "react/jsx-runtime";
var DefaultHero = forwardRef(
  function DefaultHero2({
    title,
    description,
    className,
    background = "bg-display-50",
    inCarousel,
    imageBackgroundFill = false,
    images,
    tag,
    isWhiteText,
    buttons,
    imageBorder = "bottom-ritgh"
  }, ref) {
    const isBorderFull = imageBorder === "full";
    return /* @__PURE__ */ jsx("section", { ref, className: `${className} flex w-full ${background}`, children: /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames(
          "flex flex-col md:flex-row gap-16 md:gap-24 lg:gap-40 justify-between md:justify-center lg:justify-between items-center md:pl-24 xl:pl-16 2xl:pl-0 m-auto w-full max-w-[455px] md:max-w-[1280px]",
          {
            "pt-24 md:pt-0 gap-24": isBorderFull,
            "items-start md:items-center mt-0 !xs:pt-40 !md:pt-0 md:h-full": inCarousel
          }
        ),
        children: [
          !imageBackgroundFill && /* @__PURE__ */ jsx(
            "div",
            {
              className: classNames(
                "md:hidden overflow-hidden relative w-full h-[300px]",
                {
                  "flex h-[312px] w-[calc(100%-48px)] order-2 rounded-2xl mb-24": isBorderFull,
                  "rounded-br-[42px]": !isBorderFull,
                  "mb-0": inCarousel
                }
              ),
              children: /* @__PURE__ */ jsx(
                Image_default,
                {
                  src: images.mobile.path || images.web.path,
                  alt: images.mobile.alternativeText || images.web.alternativeText,
                  layout: "fill",
                  className: `object-cover ${isBorderFull ? "rounded-2xl" : "rounded-br-[42px]"}`
                }
              )
            }
          ),
          /* @__PURE__ */ jsxs(
            "div",
            {
              className: classNames(
                "flex flex-col md:flex-1 lg:flex-initial gap-8 lg:gap-16 items-center md:items-start px-24 md:px-0 pb-40 md:pb-0 lg:max-w-[565px] text-center md:text-left",
                {
                  "pb-0": isBorderFull,
                  "!text-left": inCarousel && !imageBackgroundFill
                }
              ),
              children: [
                tag && /* @__PURE__ */ jsx(
                  "p",
                  {
                    className: "mb-8 font-bold text-stone-700 uppercase text-sm leading-2",
                    dangerouslySetInnerHTML: {
                      __html: tag
                    }
                  }
                ),
                /* @__PURE__ */ jsx(
                  "h1",
                  {
                    className: classNames(
                      "font-display text-[36px] lg:text-[48px] font-black leading-[44px] lg:leading-[56px] text-center md:text-left z-10",
                      {
                        "text-display-0 max-w-[290px] xs:max-w-none": isWhiteText,
                        "!text-left max-w-none": inCarousel,
                        "sm:mt-24": imageBackgroundFill
                      }
                    ),
                    dangerouslySetInnerHTML: {
                      __html: title
                    }
                  }
                ),
                /* @__PURE__ */ jsx(
                  "p",
                  {
                    className: classNames(
                      "w-full text-lg lg:text-2xl leading-[26px] lg:leading-6 text-center md:text-left z-10",
                      {
                        "text-display-0": isWhiteText,
                        "!text-left": inCarousel
                      }
                    ),
                    dangerouslySetInnerHTML: {
                      __html: description
                    }
                  }
                ),
                (buttons == null ? void 0 : buttons.length) && /* @__PURE__ */ jsx("div", { className: "flex z-10 flex-col md:flex-row gap-16 mt-8 w-full", children: buttons == null ? void 0 : buttons.map((props, index) => /* @__PURE__ */ jsx(
                  Button_default,
                  {
                    ...props,
                    className: classNames({
                      "w-max": inCarousel && !imageBackgroundFill,
                      "w-full md:w-max": !inCarousel
                    })
                  },
                  `${props.label}-${index}`
                )) })
              ]
            }
          ),
          imageBackgroundFill && /* @__PURE__ */ jsx("div", { className: classNames("flex md:hidden overflow-hidden"), children: /* @__PURE__ */ jsx(
            Image_default,
            {
              src: images.mobile.path || images.web.path,
              alt: images.mobile.alternativeText || images.web.alternativeText,
              layout: "fill",
              className: "object-cover"
            }
          ) }),
          /* @__PURE__ */ jsx(
            "div",
            {
              className: classNames(
                "hidden md:flex lg:hidden overflow-hidden flex-1 lg:flex-initial md:min-w-[372px] md:min-h-[576px] lg:rounded-br-10xl",
                {
                  "md:min-h-[364px] md:items-center": isBorderFull
                }
              ),
              children: /* @__PURE__ */ jsx(
                Image_default,
                {
                  src: images.tablet.path || images.web.path,
                  alt: images.tablet.alternativeText || images.web.alternativeText,
                  layout: imageBackgroundFill ? "fill" : void 0,
                  width: imageBackgroundFill ? void 0 : inCarousel ? 362 : isBorderFull ? 348 : 500,
                  height: imageBackgroundFill ? void 0 : inCarousel ? 380 : isBorderFull ? 284 : 576,
                  className: classNames("object-cover rounded-br-6xl", {
                    "rounded-2xl ": isBorderFull
                  })
                }
              )
            }
          ),
          /* @__PURE__ */ jsx(
            "div",
            {
              className: classNames(
                "hidden lg:flex overflow-hidden flex-1 lg:flex-initial lg:min-w-[500px] lg:min-h-[576px] xl:min-h-[664px]",
                {
                  "lg:min-h-[660px] lg:items-center mr-24": isBorderFull,
                  "!mr-0": inCarousel
                }
              ),
              children: /* @__PURE__ */ jsx(
                Image_default,
                {
                  src: images.web.path,
                  alt: images.web.alternativeText,
                  layout: imageBackgroundFill ? "fill" : void 0,
                  width: imageBackgroundFill ? void 0 : inCarousel ? 556 : isBorderFull ? 600 : 675,
                  height: imageBackgroundFill ? void 0 : inCarousel ? 464 : isBorderFull ? 500 : 576,
                  className: imageBackgroundFill ? "object-cover overflow-hidden" : classNames("object-cover overflow-hidden", {
                    "rounded-tl-6xl lg:rounded-tl-10xl": imageBorder === "top-left",
                    "rounded-br-6xl lg:rounded-br-10xl": imageBorder === "bottom-ritgh" || imageBorder === null,
                    "rounded-bl-6xl lg:rounded-bl-10xl": imageBorder === "bottom-left",
                    "rounded-tr-6xl lg:rounded-tr-10xl": imageBorder === "top-right",
                    "lg:rounded-6xl": isBorderFull
                  })
                }
              )
            }
          )
        ]
      }
    ) });
  }
);
var DefaultHero_default = DefaultHero;

export {
  DefaultHero_default
};
